export const paymentMethodQueryKeys = {
  all: ["payment-methods"] as const,
  entity: (id: string) =>
    [...paymentMethodQueryKeys.all, "entity", id] as const,
};

export default paymentMethodQueryKeys;
